export const EnumRoutesAppWeb = Object.freeze({
  auth: "Login",
  home: 'Ninno',
  blog: 'Blog',
  shopping: 'Shopping',
  blogCategories: 'Categorias',
  desenvolver: 'Desenvolver',
  users: 'Usuários',
  showUser: "usuário",
  dashboard: 'Dashboard',
  createEditCategory: "Categoria",
  createEditShopping: "Item Shopping",
  createEditBlog: 'Artigo',
  createEditActivity: "Atividade",
  activities: "Atividades",
  createEditExtra: "Extra",
  extras: "Extras",
  createEditDesenvolvimento: "Desenvolimento",
  banners: "Banners",
  createEditBanner: "Banner",
  pushes: "Pushes",
  createEditPush: "Push"
})
